interface Amenity {
  name: string
}

interface AmenitiesTabProps {
  amenities: Amenity[]
}

const AmenitiesTab = ({ amenities }: AmenitiesTabProps) => {
  if (!amenities?.length) {
    return null
  }

  return (
    <div className="animate-fade-in-up">
      <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">Amenities</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
        {amenities.map((amenity, index) => (
          <div
            key={`${amenity.name}-${index}`}
            className="flex items-center gap-3 p-3 sm:p-4 rounded-xl bg-gray-50 border border-gray-100"
          >
            <span className="h-2 w-2 rounded-full bg-primary-500 shrink-0" />
            <span className="text-sm sm:text-base text-gray-800 font-medium">{amenity.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AmenitiesTab
